<template>
  <v-container class="cmp-catalog-releases-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedReleaseDetails &&
              selectedReleaseDetails.release &&
              selectedReleaseDetails.release.release_title
            "
          >
            <span>{{
              (selectedReleaseDetails &&
                selectedReleaseDetails.release &&
                selectedReleaseDetails.release.release_title) ||
              $t("release_title")
            }}</span>
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div>
                {{
                  (selectedReleaseDetails &&
                    selectedReleaseDetails.release &&
                    selectedReleaseDetails.release.release_artist) ||
                  $t("release_artist")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="releasesSidewindowTabs"
        :options="[
          {
            text: $t('documents_string'),
            value: 'documents',
          },
        ]"
        @optionClicked="onTabOptionClicked"
      >
        <!-- :loading="selectedReleaseDetails && selectedReleaseDetails.loading" -->
        <gtab>
          <grow>
            <gcol>
              <!-- v-if="selectedReleaseDetails && releasesCatalogData" -->
              <gbox
                :title="$t('release_setup')"
                h="324"
                :loading="
                  selectedReleaseDetails.releaseDetailsTabOverview_loading
                "
              >
                <ReleaseSetup
                  :selectedReleaseDetails="selectedReleaseDetails"
                  @changed="onUpdated"
                />
              </gbox>

              <gbox
                :loading="
                  selectedReleaseDetails.releaseDetailsTabOverview_loading
                "
                :title="$t('notes')"
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :id="'notes'"
                  :value="selectedReleaseDetails.release.notes"
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.related_genres &&
                      selectedReleaseDetails.related_genres.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 15,
                  })
                "
                :loading="
                  selectedReleaseDetails.releaseDetailsTabOverview_loading
                "
                :title="$t('genres')"
              >
                <Genres
                  :selectedReleaseDetails="selectedReleaseDetails"
                  @delete="onGenreDelete"
                  @change="onGenreChange"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedReleaseDetails &&
                      selectedReleaseDetails.contact_relations &&
                      selectedReleaseDetails.contact_relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
                :loading="
                  selectedReleaseDetails.releaseDetailsTabOverview_loading
                "
              >
                <RealtedContacts
                  :contact_relations="selectedReleaseDetails.contact_relations"
                  :external_id="`${selectedReleaseDetails.release.release_id}`"
                  :external_table="'release'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedReleaseDetails &&
                      selectedReleaseDetails.links &&
                      selectedReleaseDetails.links.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :loading="selectedReleaseDetails.getLinks_loading"
                :title="$t('related_links')"
              >
                <ReleatedLink
                  @change="onLinkChange"
                  @delete="onRelatedLinkDelete"
                  :selectedReleaseDetails="selectedReleaseDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>

        <gtab id="tab_title_tasks">
          <grow>
            <gbox
              :h="
                boxHeightNamed({
                  rowCount:
                    selectedReleaseDetails &&
                    selectedReleaseDetails.tasks &&
                    selectedReleaseDetails.tasks.length+1,
                  offset: NTOffsets.WithHeaderDBoxBottom,
                  min: 1,
                  
                })
              "
              :title="$t('tab_title_tasks')"
            >
              <DTTaskList :storeConfig="dBoxTaskConfig" :selectedDetails="selectedReleaseDetails" :externalTable="'release'"/>
            </gbox>
          </grow>
        </gtab>

        <gtab :title="$t('tab_releases_product')" id="product">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.l_contract_pos &&
                      selectedReleaseDetails.l_contract_pos.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$t('releases_contract')"
                :loading="
                  selectedReleaseDetails.releaseDetailsTabProducts_loading
                "
              >
                <Contract
                  v-if="
                    selectedReleaseDetails && selectedReleaseDetails.release
                  "
                  :selectedReleaseDetails="selectedReleaseDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedReleaseDetails &&
                      selectedReleaseDetails.related_products &&
                      selectedReleaseDetails.related_products.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="`${$t('releases_related_products')} (${relatedProductLength})`"
                :loading="
                  selectedReleaseDetails.releaseDetailsTabProducts_loading
                "
              >
                <RelatedProducts
                  :selectedReleaseDetails="selectedReleaseDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.tracks_only &&
                      selectedReleaseDetails.tracks_only.length,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                  })
                "
                :title="`${$t('releases_related_tracks')} (${relatedTrackLength})`"
                :loading="
                  selectedReleaseDetails.releaseDetailsTabProducts_loading
                "
              >
                <RelatedTracks
                  :selectedReleaseDetails="selectedReleaseDetails"
                />
              </gbox>
              <gbox
                v-if="
                  selectedReleaseDetails &&
                  selectedReleaseDetails.release &&
                  selectedReleaseDetails.hasOwnProperty('licences')
                "
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.related_licences &&
                      selectedReleaseDetails.related_licences.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedReleaseDetails.releaseDetailsTabProducts_loading
                "
                :title="$t('releases_licences')"
              >
                <License :selectedReleaseDetails="selectedReleaseDetails" />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedReleaseDetails &&
                      selectedReleaseDetails.artists &&
                      selectedReleaseDetails.artists.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('releases_artist')"
                :loading="
                  selectedReleaseDetails.releaseDetailsTabProducts_loading
                "
              >
                <Artist
                  @change="onArtistChange"
                  @delete="onDeleteArtist"
                  :selectedReleaseDetails="selectedReleaseDetails"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedReleaseDetails &&
                      selectedReleaseDetails.matched_accounts &&
                      selectedReleaseDetails.matched_accounts.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('releases_manual_matches')"
                :loading="selectedReleaseDetails.releaseMatchedAccounts_loading"
              >
                <ManualMatches
                  :selectedReleaseDetails="selectedReleaseDetails"
                  @delete="onMatchedAccountDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="costs">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex" style="align-items: right">
                  <div>
                    <button
                      class="dt-button dt-button v5 s8"
                      @click="onReleaseCostOtherIncomeAccountAll"
                      style="margin-top: 8px; margin-left: 0px"
                    >
                      {{ $t("account_all") }}
                    </button>
                  </div>
                  <div class="ut-fc" style="margin-left: 8px">
                    <div class="ut-flex ut-text-secondary">
                      <span style="min-width: 120px">{{ $t("release") }}:</span>
                      <div style="flex: 1; text-align: right">
                        <!-- {{
                        $dft.curr(selectedReleaseDetails.release_costs_total)
                      }} -->
                        {{
                          $dft.curr(selectedReleaseDetails.release_costs_total)
                        }}
                        {{ $store.getters.account.client.default_currency }}
                      </div>
                    </div>
                    <div class="ut-flex ut-text-secondary">
                      <span style="min-width: 120px"
                        >{{ $t("related_products") }}:</span
                      >
                      <div style="flex: 1; text-align: right">
                        {{
                          $dft.curr(selectedReleaseDetails.product_costs_total)
                        }}
                        {{ $store.getters.account.client.default_currency }}
                      </div>
                    </div>
                    <div class="ut-flex ut-text-secondary">
                      <span style="min-width: 120px"
                        >{{ $t("grand_total") }}:</span
                      >
                      <div style="flex: 1; text-align: right">
                        {{
                          $dft.curr(
                            +selectedReleaseDetails.release_costs_total +
                              +selectedReleaseDetails.product_costs_total
                          )
                        }}
                        {{ $store.getters.account.client.default_currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxCostsRowCount,
                    offset:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.costs &&
                      selectedReleaseDetails.costs.length > 0
                        ? dBoxCostSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52
                          : NTOffsets.WithHeaderDBoxBottom
                        : dBoxCostSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
                :title="$t('rcpb_cost')"
                :loading="selectedReleaseDetails.costTab_loading"
              >
                <DboxCosts
                  v-if="
                    selectedReleaseDetails &&
                    selectedReleaseDetails.release.release_id
                  "
                  :items="selectedReleaseDetails.costs || []"
                  :cost_groups="
                    (releaseCatalogMetaData &&
                      releaseCatalogMetaData.cost_groups) ||
                    []
                  "
                  :storeConfig="dboxCostConfig"
                  @updated="onReleaseCostUpdated"
                  @showSearchFlag="onDBoxCostSearchFlagChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="other_income">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex" style="align-items: right">
                  <div>
                    <button
                      class="dt-button dt-button v5 s8"
                      @click="onReleaseCostOtherIncomeAccountAll"
                      style="margin-top: 8px; margin-left: 0px"
                    >
                      {{ $t("account_all") }}
                    </button>
                  </div>
                  <div class="ut-fc" style="margin-left: 8px">
                    <div class="ut-flex ut-text-secondary">
                      <span style="min-width: 120px">{{ $t("release") }}:</span>
                      <div style="flex: 1; text-align: right">
                        <!-- {{
                        $dft.curr(selectedReleaseDetails.release_costs_total)
                      }} -->
                        {{
                          $dft.curr(
                            selectedReleaseDetails.release_other_incomes_total
                          )
                        }}
                        {{ $store.getters.account.client.default_currency }}
                      </div>
                    </div>
                    <div class="ut-flex ut-text-secondary">
                      <span style="min-width: 120px"
                        >{{ $t("related_products") }}:</span
                      >
                      <div style="flex: 1; text-align: right">
                        {{
                          $dft.curr(
                            selectedReleaseDetails.product_other_incomes_total
                          )
                        }}
                        {{ $store.getters.account.client.default_currency }}
                      </div>
                    </div>
                    <div class="ut-flex ut-text-secondary">
                      <span style="min-width: 120px"
                        >{{ $t("grand_total") }}:</span
                      >
                      <div style="flex: 1; text-align: right">
                        {{
                          $dft.curr(
                            +selectedReleaseDetails.release_other_incomes_total +
                              +selectedReleaseDetails.product_other_incomes_total
                          )
                        }}
                        {{ $store.getters.account.client.default_currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxOtherIncomesRowCount,
                    offset:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.other_incomes &&
                      selectedReleaseDetails.other_incomes.length > 0
                        ? dBoxOtherIncomeSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52
                          : NTOffsets.WithHeaderDBoxBottom
                        : dBoxOtherIncomeSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
                :title="$t('channel_income')"
                :loading="selectedReleaseDetails.otherIncomeTab_loading"
              >
                <DboxCosts
                  v-if="
                    selectedReleaseDetails &&
                    selectedReleaseDetails.release.release_id
                  "
                  :items="selectedReleaseDetails.other_incomes || []"
                  :cost_groups="
                    (releaseCatalogMetaData &&
                      releaseCatalogMetaData.cost_groups) ||
                    []
                  "
                  :storeConfig="dboxCostIncomeConfig"
                  @updated="onReleaseOtherIncomeUpdated"
                  @showSearchFlag="onDBoxOtherIncomeSearchFlagChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="sales">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-d-flex">
                  <button
                    style="margin-top: 8px; margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onReleaseReportClicked"
                  >
                    {{ $t("release_report") }}
                  </button>
                  <button
                    style="margin-top: 8px"
                    class="dt-button v5 s8"
                    @click="onUpdateReportClicked"
                  >
                    {{ $t("btn_update_report") }}
                  </button>
                  <p class="ut-text-secondary" style="margin-top: 8px">
                    {{ $t("last_update") }}: {{ formatDate }}
                  </p>
                </div>
              </gcol>
            </grow>
          </template>
          <grow
            :loading="selectedReleaseDetails.releaseDetailsTabSales_loading"
          >
            <gcol>
              <ReleaseSales />
            </gcol>
          </grow>
        </gtab>
        <gtab id="info">
          <grow>
            <gcol>
              <gbox
                :loading="selectedReleaseDetails.releaseDetailsTabText_loading"
                :title="$t('release_info_english')"
              >
                <DBoxTextarea
                  :id="'release_info_english'"
                  :style="{ backgroundColor: 'white' }"
                  :value="selectedReleaseDetails.release.release_info_english"
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'release_info_english',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
              <gbox
                :loading="selectedReleaseDetails.releaseDetailsTabText_loading"
                h="308"
                :title="$t('artwork_cover')"
              >
                <Artwork
                  :artwork1="selectedReleaseDetails.artwork1"
                  :artwork2="selectedReleaseDetails.artwork2"
                  :externalId="`${this.release_id}`"
                  :externalTable="'release'"
                  :externalKey="'release_id'"
                  :section="'releases'"
                  @artworkChanged="onArtworkChanged"
                  @done="onArtworkUploadDone"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('release_info_second_language')"
                :loading="selectedReleaseDetails.releaseDetailsTabText_loading"
              >
                <DBoxTextarea
                  :id="'release_info_second'"
                  :style="{ backgroundColor: 'white' }"
                  :value="selectedReleaseDetails.release.release_info_second"
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'release_info_second',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedReleaseDetails &&
                      selectedReleaseDetails.related_files &&
                      selectedReleaseDetails.related_files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :loading="selectedReleaseDetails.releaseDetailsTabText_loading"
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedReleaseDetails.related_files"
                  :externalId="`${this.release_id}`"
                  :externalTable="'release'"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <!-- </Sidewindow> -->
    <ModalContainer
      :modalKey="'addGenre'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddGenreModal @create="createGenre" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'addLink'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddLinkModal @create="createLink" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'addManualMatch'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddManualMatchModal @create="createManualMatch" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'addArtist'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddArtistModal @create="createArtist" @cancelled="onCancel" />
    </ModalContainer>
    <!-- <ModalContainer
      :modalKey="'documentModal'"
      :width="'1200'"
      @cancelled="onCancel"
    >
      <DocumentsModal @cancelled="onCancel" />
    </ModalContainer> -->
    <ModalContainer
      :modalKey="'addRelatedProduct'"
      :width="'950'"
      @cancelled="onCancel"
    >
      <AddRelatedProductModal
        @create="createRelatedProduct"
        @cancelled="onCancel"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import * as ActionTypes from "../../store/types";
import BoxWidget from "@plugins/box-widget/box-widget";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { openWindow, wait } from "../../../../utility";
import { getBaseUrl, HttpClient } from "../../../../services/http/http-client";
import { releasesListLDTRoutes } from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";

import {
  createModalMixin,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { tv } from "../../../../models/text-value.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createLanguageTV } from "../../../../models/language.model";
import { createUserTV } from "../../../../models/user.model";

import { productsCatalogGetters } from "../../store/products/getters";
import { productsCatalogActions } from "../../store/products/actions";
import {
  CatalogStoreNamespace,
  CatalogStoreNamespace as storeNS,
} from "../../store";
import { mapGetters, mapActions } from "vuex";
import { pathOr } from "ramda";
import { releasesCatalogGetters } from "../../store/releases/getters";
import ReleaseSetup from "./release-setup";
import ReleatedLink from "./releated-link";
import Genres from "./genres";
import RelatedContact from "./related-contact";
import Artist from "./artist";
import ManualMatches from "./manual-matches";
import RelatedFile from "./related-files";
import RelatedProducts from "./related-products";
import RelatedTracks from "./related-tracks";
import ReleaseSales from "./release-sales";
import License from "./license";
import Contract from "./contract";
import Costs from "./costs";
import AddGenreModal from "./add-genre-modal";
// import DocumentsModal from "./documents-modal";
import AddLinkModal from "./add-link-modal";
import AddManualMatchModal from "./add-manual-matches-modal";
import AddArtistModal from "./add-artist-modal";
import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import DonutChart from "./donutchart";
import BarChart from "./bar-chart";
import AddRelatedProductModal from "./add-related-products-modal";
// import Artwork from './artwork'
import Artwork from "@dtplugins/artwork/artwork";
import DboxCosts from "@dtplugins/dbox-costs/dbox-costs";
import { createDboxCostConfig } from "../../../../dt-plugins/dbox-costs/dbox-costs.model";

import { releasesCatalogActions } from "../../store/releases/actions";
import { format, formatDistance, formatRelative, subDays } from "date-fns";
import { DISTRIBUTION_URL } from "../../../../services/common-urls";
//import DTTaskList from "@/dt-plugins/dt-task/dt-related-task.vue";
import DTTaskList from "@/dt-plugins/dt-task/dt-related-task-list.vue";
import { createDboxConfig } from "../../../../dt-plugins/dt-task/dbox-task.model";
export const moduleRoute = "catalog";
export const submenuRoute = "releases";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    DboxCosts,

    ReleaseSetup,
    ReleatedLink,
    Genres,
    RelatedContact,
    Artist,
    ManualMatches,
    RelatedFile,
    RelatedProducts,
    RelatedTracks,
    License,
    Contract,
    Costs,
    RealtedContacts,
    AddGenreModal,
    // DocumentsModal,
    AddLinkModal,
    AddManualMatchModal,
    AddArtistModal,
    ModalContainer,
    DBoxFiles,
    DonutChart,
    AddRelatedProductModal,
    Artwork,
    BarChart,
    ReleaseSales,
    DTTaskList,
    // Sidewindow,
    // InvoiceLinesForward,
  },
  props: {},
  mounted: function () {
    // console.log("WEREEERRRR", this.selectedReleaseDetails);
  },
  data: function () {
    return {
      active: -1,

      lockLoading: false,
      formatDate: format(new Date(), "YYYY-MM-DD HH:MM:SS"),

      dBoxCostSearchFlag: false,
      dBoxOtherIncomeSearchFlag: false,
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addRelatedProduct"),
    createModalMixin("addLink"),
    createModalMixin("documentModal"),
    createModalMixin("addGenre"),
    createModalMixin("addManualMatch"),
    createModalMixin("addArtist"),
  ],

  computed: {
    ...mapGetterObject(storeNS, releasesCatalogGetters),

    relatedProductLength:function(){
      return this.selectedReleaseDetails 
                && this.selectedReleaseDetails.related_products && 
                this.selectedReleaseDetails.related_products.length||0   
    },

    relatedTrackLength:function(){
      return this.selectedReleaseDetails 
              && this.selectedReleaseDetails.tracks_only && 
              this.selectedReleaseDetails.tracks_only.length||0   
    },


    releasesSidewindowTabs: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info"),
        },

        {
          route: "tab_title_tasks",
          value: this.$t("tab_title_tasks"),
        },

        {
          route: "product",
          value: this.$t("tab_releases_product"),
        },
        {
          route: "costs",
          value: this.$t("tab_releases_costs"),
        },
        {
          route: "other_income",
          value: this.$t("tab_releases_other_income"),
        },
        {
          route: "sales",
          value: this.$t("tab_releases_sales"),
        },
        {
          route: "info",
          value: this.$t("tab_releases_info"),
        },
      ]);
    },

    release_id: function () {
      return this.$route.params.release_id;
    },

    selectedReleaseDetails: function () {
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      console.log(
        releaseDetails,
        "::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::"
      );

      const release = releaseDetails.release || {};

      const projects = releaseDetails.projects || [];

      const projectsTV = projects.map(tv("project_name", "project_id"));

      const labels = releaseDetails.labels || [];
      const release_types = releaseDetails.release_types || [];

      const labelsTV = labels.map(tv("label_name", "label_id"));
      const release_typesTV =
        release_types?.map((e) => {
          return {
            text: this.$t(e["textkey"]),
            value: e["value"],
          };
        }) || [];

      const label_statuses = releaseDetails.label_statuses || [];

      const licences = releaseDetails.licences || [];

      const l_contract_pos = releaseDetails.l_contract_pos || [];

      const label_statusesTV = label_statuses.map(
        tv("label_status_name", "label_status_id")
      );

      const links = releaseDetails.links || [];
      return {
        ...releaseDetails,
        release,
        projects,
        projectsTV,
        labels,
        labelsTV,
        label_statuses,
        licences,
        l_contract_pos,
        label_statusesTV,
        release_typesTV,
        links,
      };
    },

    //NEED TO CLEAN UP
    countryChartData: function () {
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};

      const countries = sales_report.countries || [];

      if (countries.length == 0) {
        return [];
      }

      const total_sales = countries.reduce((accm, cur) => accm + cur.amount, 0);

      const other_total_sales =
        total_sales -
        countries
          .slice(0, 11)
          .filter((e) => e.iso2 != null)
          .reduce((accm, cur) => accm + cur.amount, 0);
      if (!total_sales) {
        return [];
      }

      // const first10 = countries.map(e => ({...e, perc: e.amount / total_sales * 100})).slice(0, 11).filter(e => e.iso2 != null);
      // const first10Sum = first10.reduce((accm, cur) => accm + cur.perc, 0);
      // const rowVal = 100 - first10Sum;
      // console.log("Row Value" , rowVal);

      let final_array = countries
        .slice(0, 11)
        .filter((e) => e.iso2 != null)
        .map((e) => {
          let salePercentage = +((e.amount / total_sales) * 100).toFixed(2);
          return {
            labels: e.iso2 + " " + salePercentage.toFixed(2) + "%",
            data: e.amount,
            salePercentage,
          };
        });

      const first10Percentage = final_array
        .reduce((accm, cur) => accm + cur.salePercentage, 0)
        .toFixed(2);
      const rowValue = (100 - first10Percentage).toFixed(2);

      final_array.push({
        labels: "Row" + " " + rowValue + " % ",
        data: other_total_sales,

        salePercentage: rowValue,
      });

      ///const t= final_array.reduce((accm,cur)=>accm+cur. salePercentage,0)
      console.log("TOTAL COUNTRY SALE::::", first10Percentage);
      return final_array;
    },
    physicalChartData: function () {
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};
      const physical_data = sales_report.physical_data || [];
      const catalogs = sales_report.catalogs || [];
      if (catalogs.length == 0) {
        return [];
      }
      const physical_dataElementLength = catalogs.length;

      const zeroArray = [...Array(physical_dataElementLength).keys()].map(
        (e) => 0
      );

      const physical_data_reduce = physical_data.reduce((accum, cur) => {
        return [...Array(physical_dataElementLength).keys()].map(
          (_, i) => accum[i] + cur[i]
        );
      }, zeroArray);

      const total_sales = physical_data_reduce.reduce((acc, cur) => acc + cur);
      if (!total_sales) {
        return [];
      }
      const final_array = physical_data_reduce.map((_, i) => {
        return {
          labels:
            catalogs[i].catalog_no +
            " " +
            ((physical_data_reduce[i] / total_sales) * 100).toFixed() +
            "%",
          data: physical_data_reduce[i],
        };
      });

      // console.log("::::", {
      //   physical_data,
      //   physical_data_reduce,
      //   final_array,
      // });

      return final_array;
    },

    salesTypeChartData: function () {
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};

      const sales_type = sales_report.sales_type || [];

      const total_sales = sales_type.reduce((accm, cur) => accm + cur[1], 0);
      // console.log("total_sales:::", total_sales, sales_type);
      if (!total_sales) {
        return [];
      }
      return sales_type.map((e) => {
        let salePercentage = (e[1] / total_sales) * 100;
        return {
          ["labels"]: e[0] + " " + salePercentage.toFixed(2) + "%",
          ["data"]: e[1],
        };
      });
    },
    dBoxTaskConfig:function(){
      return createDboxConfig({
        storeNamesPace: CatalogStoreNamespace,
        detailsAction: ActionTypes.ReleaseDetails,
        detailsGetterKey: "releaseDetails",
        dataKey: "tasks",
        primaryKeyValue: this.release_id,
        externalTable: "release",
      })
    },

    dboxCostConfig: function () {
      return createDboxCostConfig({
        storeNamesPace: CatalogStoreNamespace,
        detailsAction: ActionTypes.ReleaseDetails,
        detailsGetterKey: "releaseDetails",
        dataKey: "costs",
        primaryKeyValue: this.release_id,
        externalTable: "release",
      });
    },
    dboxCostIncomeConfig: function () {
      return createDboxCostConfig({
        storeNamesPace: CatalogStoreNamespace,
        detailsAction: ActionTypes.ReleaseDetails,
        detailsGetterKey: "releaseDetails",
        dataKey: "other_incomes",
        primaryKeyValue: this.release_id,
        externalTable: "release_income",
      });
    },

    barChartData: function () {
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};
      // const physical_data = sales_report.physical_data || [];
      // const digital_data = sales_report.digital_data || [];

      const physical_data = sales_report.physical_product_sales || [];

      const digital_data = sales_report.digital_shop_sales || [];

      // const catalogs = sales_report.catalogs || [];
      // const sales_type = sales_report.sales_type || [];
      // if (catalogs.length == 0) {
      //   return [];
      // }
      // const physical_dataElementLength = catalogs.length;
      // const digital_dataElementLength = sales_type.length - 1;

      // const zeroArrayPhysical = [
      //   ...Array(physical_dataElementLength).keys()
      // ].map(e => 0);

      // const zeroArrayDigital = [...Array(digital_dataElementLength).keys()].map(
      //   e => 0
      // );

      // const physical_data_reduce = physical_data.reduce((accum, cur) => {
      //   return [...Array(physical_dataElementLength).keys()].map(
      //     (_, i) => accum[i] + cur[i]
      //   );
      // }, zeroArrayPhysical);

      // const digital_data_reduce = digital_data.reduce((accum, cur) => {
      //   return [...Array(digital_dataElementLength).keys()].map(
      //     (_, i) => accum[i] + cur[i]
      //   );
      // }, zeroArrayDigital);

      // const total_sales = physical_data_reduce.reduce((acc, cur) => acc + cur);
      // if (!total_sales) {
      //   return [];
      // }

      // const final_label = [
      //   ...catalogs.map((_, i) => {
      //     return catalogs[i].catalog_no;
      //   }),
      //   ...sales_type
      //     .map((_, i) => {
      //       if (sales_type[i][0] != "Physical") {
      //         return sales_type[i][0];
      //       }
      //     })
      //     .filter(e => e)
      // ];

      // const final_data_array = [
      //   ...physical_data_reduce,
      //   ...digital_data_reduce
      // ];

      // const final_array = final_data_array.map((_, i) => {
      //   return {
      //     labels: final_label[i],
      //     data: final_data_array[i]
      //   };
      // });

      const physical_data_array = physical_data.map((e) => {
        return {
          labels: e["catalog_no"],
          data: e["total_turnover"],
        };
      });

      const digital_data_array = digital_data.map((e) => {
        return {
          labels: e["shop"],
          data: e["total_turnover"],
        };
      });

      const final_array = [...physical_data_array, ...digital_data_array];

      // console.log("::::", {
      //   final_label,
      //   final_data_array,
      //   final_array,
      // });

      return final_array;
    },

    dBoxCostsRowCount: function () {
      return this.selectedReleaseDetails?.costs?.length > 0
        ? this.selectedReleaseDetails?.costs?.length
        : 0;
    },
    dBoxOtherIncomesRowCount: function () {
      return this.selectedReleaseDetails?.other_incomes?.length > 0
        ? this.selectedReleaseDetails?.other_incomes?.length
        : 0;
    },
    //NEED TO CLEAN UP
  },
  methods: {
    ...mapActionObject(storeNS, releasesCatalogActions),
    onReleaseTextboxBlur: function (name, value) {
      const payload = {
        name: name,
        value: value,
        table: "l_releases",
      };
    },

    onUpdated: async function (payload) {
      payload.item = this.selectedReleaseDetails;
      return await this[ActionTypes.ReleaseDetails.UPDATE.SINGLE](payload);
    },

    onGenreChange: function (payload) {
      payload.release = this.selectedReleaseDetails;
      this[ActionTypes.Genres.UPDATE.SINGLE](payload);
    },

    onLinkChange: function (payload) {
      this[ActionTypes.RelatedLink.UPDATE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },

    onArtistChange: function (payload) {
      this[ActionTypes.ReleaseArtist.UPDATE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },
    onCancel: function () {
      this.$router.push({
        query: {
          modal: undefined,
          external_id: undefined,
        },
      });
    },

    createGenre: function (payload) {
      this[ActionTypes.Genres.INSERT.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
      this.onCancel();
    },
    onGenreDelete: function (payload) {
      this[ActionTypes.Genres.DELETE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },

    onTabOptionClicked(value) {
      if (value == "documents") {
        openModalRoute2(this, "dtTemplateList", {
          external_id: this.release_id,
        });
      }
    },

    onDocumentsClicked: function () {
      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "document_modal",
      //     external_id: this.selectedReleaseDetails.release.release_id,
      //   },
      // });
    },
    createLink: function (payload) {
      this[ActionTypes.RelatedLink.INSERT.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
      this.onCancel();
    },
    onRelatedLinkDelete: function (payload) {
      this[ActionTypes.RelatedLink.DELETE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },

    createManualMatch: function (payload) {
      this[ActionTypes.ManualMatch.INSERT.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
      this.onCancel();
    },

    onMatchedAccountDelete: function (payload) {
      this[ActionTypes.ManualMatch.DELETE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },

    createArtist: function (payload) {
      this[ActionTypes.ReleaseArtist.INSERT.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
      this.onCancel();
    },
    onDeleteArtist: function (payload) {
      this[ActionTypes.ReleaseArtist.DELETE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },

    onRelatedFileDelete: function (payload) {
      this[ActionTypes.RelatedFile.DELETE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },

    onCostChange: function (payload) {
      this[ActionTypes.Cost.UPDATE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },
    onDeleteCost: function (payload) {
      this[ActionTypes.Cost.DELETE.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
    },
    onRelatedContactDelete: function (contact) {
      this[ActionTypes.ReleaseRelatedContacts.DELETE.SINGLE]({
        contact,
        release: this.selectedReleaseDetails,
      });
    },
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.ReleaseRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        release: this.selectedReleaseDetails,
      });
    },
    onReleaseReportClicked: function () {
      const url = `${getBaseUrl()}${DISTRIBUTION_URL}?section=reports&action=release_report&release_id=${
        this.release_id
      }`;
      window.open(url, "_blank");
      // console.log(url);
    },
    onUpdateReportClicked: function () {
      this[ActionTypes.ReleaseDetails.FETCH.SINGLE]({
        flag: true,
        release: this.selectedReleaseDetails.release,
        reload: true,
      });
      //this.formatDate= format(new Date(),'YYYY-MM-DD HH:MM:SS')
    },
    onRelatedContactSelected: function () {
      //console.log(contact);
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview",
        },
      });
    },

    createRelatedProduct: function (payload) {
      console.log("::::", payload);

      this[ActionTypes.RelatedProduct.INSERT.SINGLE]({
        ...payload,
        release: this.selectedReleaseDetails,
      });
      this.onCancel();
    },
    onArtworkChanged: function (payload) {
      this[ActionTypes.SET_RELEASE_ARTWORK]({
        ...payload,
        selectedReleaseDetails: this.selectedReleaseDetails,
      });
    },
    onArtworkUploadDone: function (payload) {
      this[ActionTypes.SET_RELEASE_ARTWORK]({
        ...payload,
        selectedReleaseDetails: this.selectedReleaseDetails,
      });
      this[ActionTypes.SET_RELEASE_PRODUCT_FILES]({
        ...payload,
        selectedReleaseDetails: this.selectedReleaseDetails,
      });
    },

    onReleaseCostOtherIncomeAccountAll: async function () {
      const release_id = this.release_id;
      this.$router.push({
        name: releasesListLDTRoutes.names.list,
      });
      await wait(100);
      this.$router.push({
        path: "/main/royalty/recoupable",
        query: {
          release_id: release_id,
        },
      });
    },

    changeText: function (tooltipItem, data) {
      console.log(tooltipItem, data.datasets[0].data[tooltipItem.index]);

      const labelArray = data.labels[tooltipItem.index].split(" ");

      return `${labelArray[0]} ${data.datasets[0].data[
        tooltipItem.index
      ].toFixed(2)} (${labelArray[1]})`;
    },
    changeCursor: function (event, legendItem, legend) {
      //console.log(event, legendItem, legend);
      event.target.style.cursor = "pointer";
    },
    changeCursorOnLeave: function (event, legendItem, legend) {
      //console.log(event, legendItem, legend);
      event.target.style.cursor = "auto";
    },
    onDBoxCostSearchFlagChange(payload) {
      this.dBoxCostSearchFlag = payload;
    },
    onDBoxOtherIncomeSearchFlagChange(payload) {
      this.dBoxOtherIncomeSearchFlag = payload;
    },
    onReleaseCostUpdated(payload) {
      console.log("ssssssssspayload", payload);
      this[ActionTypes.UPDATE_RELEASE_DETAILS_STATE]({
        ...payload,
        release_id: this.release_id,
      });
    },

    onReleaseOtherIncomeUpdated(payload) {
      console.log("onReleaseOtherIncomeUpdated", payload);
      // this[ActionTypes.UPDATE_RELEASE_DETAILS_STATE]({
      //   ...payload,
      //   release_id: this.release_id,
      // });
    },
    // MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
}
</style>
